import {fetchBody} from "../../config"
import { toLogout, cleanFetch } from "../apiTools";
import { getToken } from "../../component/Login/Auth";
import { URL_PLAYER_ADD, URL_PLAYER_GET_LIST, URL_PLAYER_GET_DETAIL, URL_PLAYER_EDIT, URL_PLAYER_CHECK_NAME } from "../../setup/config_mystat";

export function api_getPlayerList ({mReqPlayerList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqPlayerList, token}), 
      url: URL_PLAYER_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_addPlayer ({isAdd=true, mRespPlayer, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    console.log(mRespPlayer)
    cleanFetch({
      body: fetchBody({body: mRespPlayer, token}), 
      url: isAdd?URL_PLAYER_ADD:URL_PLAYER_EDIT, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getPlayerDetail ({mReqPlayerDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqPlayerDetail, token}), 
      url: URL_PLAYER_GET_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_checkPlayerName ({mRespPlayer, success, failure}){
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespPlayer, token}), 
      url: URL_PLAYER_CHECK_NAME, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}